import React from 'react';
import {
  FaCode,
  FaServer,
  FaMobileAlt,
  FaLightbulb,
} from 'react-icons/fa';
import './About.css';

const highlights = [
  {
    icon: <FaCode />,
    title: 'Frontend',
    desc: 'React, JavaScript, HTML5 e CSS3 para interfaces modernas e responsivas.',
  },
  {
    icon: <FaServer />,
    title: 'Backend',
    desc: 'Java, Python e SQL para construir APIs e lógicas de negócio sólidas.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Mobile',
    desc: 'Desenvolvimento Android com Java, focado em experiência fluida.',
  },
  {
    icon: <FaLightbulb />,
    title: 'Soluções',
    desc: 'ERP, manipulação de dados e automações que resolvem problemas reais.',
  },
];

const About = () => {
  return (
    <section id="about" className="section reveal">
      <div className="section-header">
        <h2 className="section-title">Sobre Mim</h2>
        <span className="section-subtitle">
          Conheça um pouco da minha trajetória e do que faço
        </span>
      </div>

      <div className="about-grid">
        <div className="about-text">
          <p>
            Sou um desenvolvedor <strong>fullstack</strong> com formação em{' '}
            <strong>Análise e Desenvolvimento de Sistemas</strong>, apaixonado
            por transformar ideias em produtos digitais que entregam valor
            real.
          </p>
          <p>
            Tenho experiência em <strong>React</strong>,{' '}
            <strong>Java (Android)</strong>, <strong>Python</strong> e{' '}
            <strong>SQL</strong>, além de gerenciamento de ERP e manipulação
            de dados. Procuro sempre escrever código limpo, escalável e
            pensado no usuário final.
          </p>
          <p>
            Trabalho bem em equipe, comunico com clareza e estou sempre
            aprendendo — porque a tecnologia muda rápido, e quem fica parado
            fica para trás.
          </p>
        </div>

        <div className="about-cards">
          {highlights.map((item, index) => (
            <div className="about-card" key={index}>
              <div className="about-card-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
